import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'

const Wrapper = styled.section`
  margin-bottom: 100px;
`

const DownloadContainer = styled.div`
  background: ${theme.colors.primary};
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;

  ${media.xs`
    flex-wrap: wrap;
  `}
`

const TextContainer = styled.div`
  padding-right: 15%;

  ${media.xs`
    order: 2;
    padding-right: 0;
  `}
`

const IconContainer = styled.div`
  align-items: center;
  background: #D8D8D8;
  display: flex;
  justify-content: center;
  min-height: 120px;
  min-width: 120px;

  ${media.xs`
    order: 1;
    margin-bottom: 25px;
  `}
`

const Icon = styled.div`
  align-items: center;
  background: white;
  border-radius: 50px;
  display: flex;
  height: 50px;
  justify-content: center;
  width: 50px;
`

const Title = styled.h2`
  font-size: 20px;
  line-height: 28px;
`

const Description = styled.p`
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
`

export default class Download extends Component {
  render() {
    const { title, description, file } = this.props
    const sourceUrl = file.sourceUrl
    
    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col
              sm={12}
              smOffset={0}
              md={9}
              mdOffset={3}
              lg={6}
              lgOffset={4}
              xl={5}
              xlOffset={5}
            >
              <a
                href={sourceUrl}
                download
              >
                <DownloadContainer>
                  <TextContainer>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                  </TextContainer>
                  <IconContainer>
                    <Icon>
                      <svg
                        width={25}
                        height={22}
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          stroke="#969696"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <path d="M23.727 10L12.363 21.461 1 10M12 21.195V0"/>
                        </g>
                      </svg>
                    </Icon>
                  </IconContainer>
                </DownloadContainer>
              </a>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Download/index.js